import dayjs from "dayjs";

import { ICampaign } from "@/interfaces/campaign.interface";
import { CampaignStatus, CampaignType } from "@/types/campaign.types";

type UseCampaignDataMessages = {
  statusActive: string;
  statusInactive: string;
  statusDraft: string;
  statusRejected: string;
  statusCompleted: string;
  statusHold: string;
  campaignTypePromotionalPrice: string;
  campaignTypeDiscountCoupon: string;
  campaignTypeSimpleMessage: string;
};

type UseCampaignDataReturn = Partial<ICampaign> & {
  statusLabel: string;
  typeLabel: string;
  bgColor: "success" | "error" | "warning" | undefined;
  startDateFormatted: string;
  endDateFormatted: string;
};

type UseCampaignDataProps = { campaign: ICampaign | null; messages: UseCampaignDataMessages };

function useCampaignData({ campaign, messages }: UseCampaignDataProps): UseCampaignDataReturn {
  const status = campaign?.status ?? "";
  let statusLabel = "";
  let bgColor: "success" | "error" | "warning" | undefined = undefined;

  switch (status) {
    case CampaignStatus.Active:
      statusLabel = messages.statusActive;
      bgColor = "success";
      break;
    case CampaignStatus.Inactive:
      statusLabel = messages.statusInactive;
      bgColor = "error";
      break;
    case CampaignStatus.Draft:
      statusLabel = messages.statusDraft;
      bgColor = "warning";
      break;
    case CampaignStatus.Hold:
      statusLabel = messages.statusHold;
      bgColor = "warning";
      break;
    case CampaignStatus.Rejected:
      statusLabel = messages.statusRejected;
      bgColor = "error";
      break;
    case CampaignStatus.Completed:
      statusLabel = messages.statusCompleted;
      bgColor = "success";
      break;
    default:
      statusLabel = "-";
      bgColor = undefined;
  }

  const type = campaign?.type;
  let typeLabel = "";

  switch (type) {
    case CampaignType.PromotionalPrice:
      typeLabel = messages.campaignTypePromotionalPrice;
      break;
    case CampaignType.DiscountCoupon:
      typeLabel = messages.campaignTypeDiscountCoupon;
      break;
    case CampaignType.SimpleMessage:
      typeLabel = messages.campaignTypeSimpleMessage;
      break;
    default:
      typeLabel = "-";
  }

  // Formatar as datas
  const startDateFormatted = campaign?.startDate
    ? dayjs(campaign.startDate).format("DD/MM/YYYY")
    : "-";
  const endDateFormatted = campaign?.endDate ? dayjs(campaign.endDate).format("DD/MM/YYYY") : "-";

  return { ...campaign, statusLabel, typeLabel, bgColor, startDateFormatted, endDateFormatted };
}

export default useCampaignData;
